import * as React from "react";
import Table from "antd/lib/table";
import Tooltip from 'antd/lib/tooltip';
import Row from "antd/lib/row";
import { useDispatch } from "react-redux";
import { PatientAdvancedSearchForm } from './epicpetsearchform';
import Layout from "antd/lib/layout";
const { Content } = Layout;
import {format} from 'one-util-date';
import {
    setSpin,
    SEARCH,
} from 'one-state-patient-global-search';
import Skeleton from 'antd/lib/skeleton';

function sortPatientSearchDate(date: any) {
    if (date) {
        let val = format(date,'MM-DD-YYYY' )
        return val;
    } else {
        return "";
    }
}

export const EpicPatientSearchTab = (props: any) => {
    const {
        modelvalue,
        loadingspin,
        preferred_name
    } = props;
    const {
        model,
        onRowClick,
    } = modelvalue;
    let patientmodaldata: any = [];
    const dispatch = useDispatch();
    const subjects = model?.data;
    subjects.forEach((patientdata: any) => {
        let selectedpName=(patientdata?.preferredName?' "'+patientdata?.preferredName+'"':'')
        const info = {
            name: patientdata?.name ? (patientdata?.name +(preferred_name&&selectedpName)) : "",
            dob: patientdata?.dob ? patientdata?.dob : "",
            zip: patientdata?.zipcode ? patientdata?.zipcode : "",
            phone: patientdata?.phone,
            ssn: patientdata?.ssn ? patientdata?.ssn : "",
            mrn: patientdata?.mrn ? patientdata?.mrn : "",
        }
        patientmodaldata.push(info);
    })

    let dispatchMethod = async (params: any) => {
        dispatch({
            type: SEARCH,
            payload: {
                id: params.pglobalId,
                name: params.pglobalFname,
                birthdate: params.datepicker ? params.datepicker : undefined,
                phone: params.pglobalphone
            }
        });
        dispatch(
            setSpin(true)
        );
    }

    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name"
        },
        {
            title: "DOB",
            key: "dob",
            dataIndex: "dob"
        },
        {
            title: "ZIP",
            key: "zip",
            dataIndex: "zip"
        },
        {
            title: "Phone Number",
            key: "phone",
            dataIndex: "phone",
            render: (phone: any) => <Tooltip title={phone.Type}><div>{phone.Number}</div></Tooltip>
        },
        {
            title: "SSN",
            key: "ssn",
            dataIndex: "ssn"
        }

    ];

    return (
        <Layout>
            <Content>
            <section className='globalsearchcontainer' >                    
                    <header className='globalsearchheader'>
                        <Row  style={{width: "100%"}}>
                            <PatientAdvancedSearchForm dispatchMethod={dispatchMethod} />
                        </Row>
                    </header>
                    <div className="global-search-skeleton">
                    <Skeleton active loading={model?.spin} paragraph={{ rows: 3 }}>
                        <Table
                            columns={columns}
                            dataSource={patientmodaldata}
                            onRowClick={(event: string) => {
                                onRowClick(event);
                                loadingspin();
                            }}
                            pagination={{ pageSize: 5 }}
                        />
                    </Skeleton>
                    </div>
                </section>
            </Content>
        </Layout>

    );
};